"use client";

import { MutableRefObject, createContext, useContext } from "react";
export interface ChatModalsHandle {
  openPrimaryPatientModal: () => void;
}
export interface ChatModalsRefContextValue {
  chatModalsRef: MutableRefObject<ChatModalsHandle | null>;
}
export const ChatModalsRefContext = createContext<ChatModalsRefContextValue | null>(null);
export function useChatModalsRefContext() {
  const context = useContext(ChatModalsRefContext);
  if (!context) {
    throw new Error("useChatModalsRefContext must be used within a ChatModalsRefProvider");
  }
  return context;
}